import { createQueriesConfig } from '@wix/premium-fed-sdk/apis-infra';
import { getProductRevshareAmountsQueryFn } from './queries/get-product-revshare-amounts.query';
import { getRevShareAmountByProductAndCycleQueryFn } from './queries/get-revshare-amount-by-product-and-cycle.query';
import { getRevshareRateQueryFn } from './queries/get-revshare-rate.query';
export const RevShareQueriesConfig = createQueriesConfig({
  getRevshareRate: {
    queryFn: getRevshareRateQueryFn
  },
  getRevShareAmountByProductAndCycle: {
    queryFn: getRevShareAmountByProductAndCycleQueryFn
  },
  getProductRevshareAmounts: {
    queryFn: getProductRevshareAmountsQueryFn
  }
});
//# sourceMappingURL=rev-share.config.js.map